<template>
  <vx-card class="vx-card_full-height">
    <div class="vx-row items-center justify-between flex-wrap flex-shrink-0">
      <div class="vx-col w-auto flex flex items-center flex-wra">
        <h4 class="whitespace-no-wrap">Платежи</h4>
        <div class="w-auto flex flex-wrap items-center ml-2">
          <div class="mr-2 mb-2">
            <label class="vs-input--label pl-1">Период с:</label>
            <datepicker
              v-model="date_from"
              class="datepicker_small"
              format="MMMM yyyy"
              :minimumView
                ="'month'"
              :maximumView="'year'"
              :disabledDates="disabledDatesFrom"
            />
          </div>
          <div class="mr-2 mb-2">
            <label class="vs-input--label pl-1">По:</label>
            <datepicker
              v-model="date_to"
              class="datepicker_small"
              format="MMMM yyyy"
              :minimumView="'month'"
              :maximumView="'year'"
              :disabledDates="disabledDatesTo"
            />
          </div>
        </div>
      </div>

      <div class="vx-col w-auto flex items-center flex-shrink-0 md:flex-no-wrap flex-wrap">
        <vs-button type="border" class="mr-2" @click="goToUnresolvedPayments">Нераспознанные платежи</vs-button>
        <vs-button
          type="border" @click="$router.push({name: 'uc_b_payments_add'})" class="mr-2 whitespace-no-wrap"
          v-if="$can('rp.invoices', 'write')" iconPack="feather" icon="icon-plus" title="Добавить"
        />
        <vs-button
          type="border"
          @click="exportTable()"
          class=" whitespace-no-wrap"
          iconPack="feather"
          icon="icon-download"
          title="Экспортировать в CSV"
          :disabled="exportInProgress"
        />
        <!--        <vs-button-->
        <!--          type="border" @click="isImportOpen = true" class="mb-2 mr-2 whitespace-no-wrap"-->
        <!--          v-if="$can('rp.invoices', 'write')" iconPack="feather" icon="icon-upload" title="Импортировать"-->
        <!--        />-->
      </div>
    </div>

    <div class="pt-6 flex flex-col flex-1">
      <grid-infinite-scroll
        ref="table"
        :columns="columns"
        :getData="getData"
        :rowHeight="50"
        :maxConcurrentDatasourceRequests="4"
        :pinnedRowsGetters="pinnedRowsGetters"
        :getPinnedRows="getPinnedRows"
        :filterable="false"
        :sortable="false"
        noDataText="Платежи не найдены"
        :frameworkComponents="tableComponents"
        :enterMovesDownAfterEdit="true"
        :editable="$can('rp.devices', 'write')"
        :singleClickEdit="true"
      />
    </div>

    <!--    <vs-popup title="Импортировать" :active.sync="isImportOpen">-->
    <!--      <div class="vx-col w-full mb-3">-->
    <!--        <elsa-v-select-->
    <!--          :options="importTypes"-->
    <!--          v-model="paymentImportType"-->
    <!--          label="name"-->
    <!--          :reduce="item => item.id"-->
    <!--          :clearable="false"-->
    <!--          htmlLabel="Тип импорта"-->
    <!--          styleType="largeLabel"-->
    <!--        />-->

    <!--        <div v-if="paymentImportType === 'sberbank_reestr'">-->
    <!--          <upload-sberbank-txt-->
    <!--            @uploaded="sberbankImportPopupOpen=true; sberbankImportAnswer=$event.info; getPayments(true);"-->
    <!--          />-->
    <!--          <sberbank-import-popup-->
    <!--            title="Импорт завершен"-->
    <!--            :isOpen="sberbankImportPopupOpen"-->
    <!--            :info="sberbankImportAnswer"-->
    <!--            @openChanged="sberbankImportPopupOpen=$event"-->
    <!--          />-->
    <!--        </div>-->

    <!--      </div>-->
    <!--    </vs-popup>-->
    <vs-popup
      :title="newPayment.id ? 'Редактирование платежа' : 'Добавление платежа'"
      :active.sync="isNewPaymentOpen"
    >
      <form class="w-full overflow-hidden" @submit.prevent>
        <div class="vx-col w-full mb-3">
          <elsa-v-select
            :options="apartments"
            v-model="newPayment.account_number"
            label="account_number"
            :reduce="item => item.account_number"
            :clearable="false"
            htmlLabel="Лицевой счет"
            styleType="largeLabel"
            :danger="newPaymentErrors.account_number"
            danger-text="Выберите лицевой счет"
            @input="newPaymentErrors.account_number=false"
            :disabled="true"
          />
          <!--            :disabled="newPayment.id && newPayment.check_print"-->
        </div>
        <div class="vx-col w-full mb-3">
          <elsa-v-select
            :options="paymentTypes"
            v-model="newPayment.type"
            label="name"
            :reduce="item => item.id"
            :clearable="false"
            htmlLabel="Тип платежа"
            styleType="largeLabel"
            :danger="newPaymentErrors.type"
            danger-text="Выберите тип платежа"
            @input="newPaymentErrors.type=false"
            :disabled="newPayment.id && newPayment.check_print"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="newPayment-payment_create_date">Дата создания платежа</label>
          <datepicker
            class="w-full"
            ref="newPaymentCreateDate"
            format="dd.MM.yyyy"
            v-model="newPayment.payment_create_date"
            id="newPayment-payment_create_date"
            :class="{'has-error': newPaymentErrors.payment_create_date}"
            @input="newPaymentErrors.payment_create_date = false"
            :disabled="newPayment.id && newPayment.check_print"
          />
          <span v-if="newPaymentErrors.payment_create_date">
                            <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
                                <span class="span-text-validation">
                                    Выберите дату
                                </span>
                            </div>
                        </span>
        </div>
        <div class="vx-col w-full mb-3">
          <label for="newPayment-payment_passage_date">Дата проведения платежа</label>
          <datepicker
            class="w-full"
            ref="newPaymentPassageDate"
            format="dd.MM.yyyy"
            v-model="newPayment.payment_passage_date"
            id="newPayment-payment_passage_date"
            :class="{'has-error': newPaymentErrors.payment_passage_date}"
            @input="newPaymentErrors.payment_passage_date = false"
            :disabled="newPayment.id && newPayment.check_print"
          />
          <span v-if="newPaymentErrors.payment_passage_date">
                            <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
                                <span class="span-text-validation">
                                    Выберите дату
                                </span>
                            </div>
                        </span>
        </div>
        <div class="vx-col w-full mb-3" v-if="newPayment.id">
          <label for="newPayment-amount">Зачислено</label>
          <vs-input
            class="w-full" id="newPayment-amount"
            :value="(newPayment.all_amount - newPayment.amount_agency).toFixed(2)"
            autocomplete="off"
            :danger="newPaymentErrors.amount"
            danger-text="Сумма зачсления должна быть положительным числом"
            @change="newPaymentErrors.amount=false"
            :disabled="true"
          />
        </div>
        <div class="vx-col w-full mb-3" v-if="newPayment.id">
          <label for="newPayment-amount_agency">Комиссия</label>
          <vs-input
            class="w-full" id="newPayment-amount_agency"
            v-model="newPayment.amount_agency" v-currency autocomplete="off"
            :danger="newPaymentErrors.amount_agency"
            danger-text="Сумма комисии должна быть положительным числом"
            @change="newPaymentErrors.amount_agency=false"
            :disabled="newPayment.id && newPayment.check_print"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="newPayment-value">Сумма</label>
          <vs-input
            class="w-full" id="newPayment-value"
            v-model="newPayment.all_amount" v-currency autocomplete="off"
            :danger="newPaymentErrors.all_amount"
            danger-text="Сумма платежа должна быть положительным числом"
            @change="newPaymentErrors.all_amount=false"
            :disabled="newPayment.id && newPayment.check_print"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="newPayment-monthyear">Месяц назначения платежа</label>
          <datepicker
            class="w-full"
            ref="newPaymentMonthyear"
            format="MMMM yyyy"
            minimum-view="month"
            maximum-view="year"
            v-model="newPayment.monthyear"
            id="newPayment-monthyear"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="newPayment-check_number">Номер чека</label>
          <vs-input
            class="w-full" id="newPayment-check_number"
            v-model="newPayment.check_number" autocomplete="off"
            :danger="newPaymentErrors.check_number"
            danger-text="Поле обязательное для заполнения"
            @change="newPaymentErrors.check_number=false"
            :disabled="newPayment.id && newPayment.check_print"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="newPayment-register">Register</label>
          <vs-input
            class="w-full" id="newPayment-register"
            v-model.number="newPayment.register" autocomplete="off" type="number"
            :danger="newPaymentErrors.register"
            danger-text="Поле обязательное для заполнения"
            @change="newPaymentErrors.register=false"
            :disabled="newPayment.id && newPayment.check_print"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="newPayment-comment">Комментарий</label>
          <vs-textarea id="newPayment-comment" v-model="newPayment.comment" class="w-full" />
        </div>
        <div class="vx-col w-full mb-3">
          <vs-checkbox
            class="mb-4 mr-2" v-model="newPayment.check_print"
            :disabled="newPayment.id && newPayment.check_print"
          >Чек распечатан
          </vs-checkbox>
        </div>
        <div class="vx-col w-full flex justify-center">
          <vs-button type="filled" color="primary" @click.prevent="addPayment" class="mt-4 mr-4">
            Сохранить
          </vs-button>
        </div>
      </form>

      <vs-popup
        :active.sync="isIdenticPaymentsOpen" title="Платежи похожие на существующие"
        class="identicPaymentPopup"
      >

        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-table :data="identicPayments">
              <template slot="thead">
                <vs-th>Л/с</vs-th>
                <vs-th>Сумма</vs-th>
                <vs-th style="width: 120px">Дата создания</vs-th>
                <vs-th style="width: 140px">Дата проведения</vs-th>
                <vs-th style="width: 180px">Обновление в системе</vs-th>
                <vs-th>Источник</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    {{ tr.account_number }}
                  </vs-td>
                  <vs-td>
                    {{ tr.amount }}
                  </vs-td>
                  <vs-td>
                    {{ $options.filters.moment($parseDateFromString(tr.payment_create_date)) }}
                  </vs-td>
                  <vs-td>
                    {{ $options.filters.moment($parseDateFromString(tr.payment_passage_date)) }}
                  </vs-td>
                  <vs-td>
                    {{ $options.filters.moment(tr.updated_at) }}
                  </vs-td>
                  <vs-td>
                    {{ tr.author ? tr.author.name : tr.resolved_by }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col w-full flex items-center justify-center">
            <vs-button class="mr-4" @click="addIdenticPayment">Добавить</vs-button>
            <vs-button type="border" @click="isIdenticPaymentsOpen = false;">Отменить</vs-button>
          </div>
        </div>

      </vs-popup>
    </vs-popup>
  </vx-card>
</template>

<script>
import UploadSberbankTxt   from "@/components/calculated-program/import/UploadSberbankTxt";
import SberbankImportPopup from "@/components/calculated-program/import/SberbankImportPopup";
import agGridActions       from "@/components/calculated-program/payments/AgGridActions";

import AccountNumberRenderer from "@/components/employee/accounts/AccountNumberRenderer";
import MonthYearEditor       from "@/components/calculated-program/payments/MonthYearEditor";
import PaymentCheck          from "@/components/calculated-program/payments/PaymentCheck";
import notifyHttpError       from "@/mixins/notifyHttpError";

const IMPORT_TYPES = [
  {
    id:   'sberbank_reestr',
    name: 'Реестр Сбербанка',
  },
];

export default {
  name:       "Payments",
  components: {
    UploadSberbankTxt,
    SberbankImportPopup,
    agGridActions,
  },
  mixins:     [notifyHttpError],
  data() {
    return {
      sberbankImportPopupOpen: false,
      sberbankImportAnswer:    {},
      // isImportOpen:            false,
      importTypes:       IMPORT_TYPES,
      paymentImportType: IMPORT_TYPES[0].id,
      date_from:         (new Date()).setMonth((new Date()).getMonth() - 3), // now - 3 month
      date_to:           Date.now(),
      isNewPaymentOpen:  false,
      newPayment:        {
        account_number:       null,
        payment_create_date:  new Date(),
        payment_passage_date: new Date(),
        all_amount:           null,
        check_number:         null,
        register:             null,
        type:                 null,
        check_print:          null,
        amount:               null,
        amount_agency:        null,
        monthyear:            null,
        comment:              null,
      },
      newPaymentErrors:  {
        account_number:       false,
        payment_create_date:  false,
        payment_passage_date: false,
        all_amount:           false,
        amount:               false,
        amount_agency:        false,
        check_number:         false,
        type:                 false,
        register:             false,
      },

      paymentTypes:          [],
      apartments:            [],
      isIdenticPaymentsOpen: false,
      identicPayments:       [],
      pinnedRowsGetters:     {
        account_number: 'Всего',
        amount:         ( data ) => {
          return this.$options.filters.numberWithSpaces(data.amount);
        },
        amount_agency:  ( data ) => {
          return this.$options.filters.numberWithSpaces(data.amount_agency);
        },
        all_amount:     ( data ) => {
          return this.$options.filters.numberWithSpaces(data.all_amount);
        },
      },
      totalAmount:           null,
      totalAmountAgency:     null,
      totalAllAmount:        null,
      tableComponents:       {
        paymentMonthYearEditor: MonthYearEditor,
      },
      exportInProgress: false,
    };
  },
  computed: {
    columns() {
      return [
        {
          headerName:            'Счет',
          field:                 'account_number',
          minWidth:              120,
          sortable:              true,
          filter:                true,
          pinned:                'left',
          editable:              false,
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
        },
        {
          headerName:  'Собственник',
          field:       'apartment_owner',
          minWidth:    320,
          sortable:    true,
          filter:      true,
          editable:    false,
          pinned:      'left',
          valueGetter: ( { data } ) => data.apartment_owner ? data.apartment_owner : '-',
        },
        {
          headerName:        'Тип',
          minWidth:          160,
          field:             'type',
          filter:            'select',
          suppressSizeToFit: false,
          editable:          false,
          filterParams:      {
            options: this.paymentTypes.map(pt => ({
              value: pt.id,
              label: pt.name,
            })).sort(( a, b ) => a.value - b.value),
          },
          valueGetter:       ( { data } ) => data.type ? this.getPaymentsTypeById(data.type) : '',
        },
        {
          headerName:        'Месяц назначения',
          field:             'monthyear',
          filter:            "date",
          filterParams:      {
            minimumView: 'month',
            showFormat:  'MMMM yyyy',
            sendFormat:  'YYYY-MM',
          },
          editable:          this.$can('rp.invoices', 'write'),
          minWidth:          120,
          suppressSizeToFit: false,
          cellEditor:        'paymentMonthYearEditor',
          cellEditorParams:  ( { value } ) => {
            return {
              value: value ? value : null,
            };
          },
          cellRenderer:      ( cell ) => {
            return cell.value ? this.$capitalize(this.$options.filters.moment(cell.value, 'MMMM YYYY')) : "-";
          },
          valueGetter:       ( { data } ) => {
            return data.monthyear ? this.$parseDateFromString(data.monthyear) : null;
          },
          valueSetter:       ( { newValue, data } ) => {
            if (newValue === null) return false;
            let oldMonthYear = data.monthyear;
            data.monthyear = newValue.value !== null ? this.$moment(newValue.value).format('YYYY-MM') : null;

            this.updatePayment(data).then(response => {
              if (!response) data.monthyear = oldMonthYear;
            }).catch(() => data.monthyear = oldMonthYear);
          },
        },
        {
          headerName:        'Добавлено в систему',
          field:             'payment_passage_date',
          filter:            "date",
          minWidth:          120,
          suppressSizeToFit: false,
          editable:          false,
          valueGetter:       ( { data } ) => {
            return data.payment_passage_date ? this.$options.filters.moment(this.$parseDateFromString(data.payment_passage_date)) : '';
          },
        },
        {
          headerName:        'Проведено по банку',
          field:             'payment_create_date',
          filter:            "date",
          minWidth:          120,
          suppressSizeToFit: false,
          valueGetter:       ( { data } ) => {
            return data.payment_create_date ? this.$options.filters.moment(this.$parseDateFromString(data.payment_create_date)) : '';
          },
        },
        {
          headerName:        'Зачислено',
          field:             'amount',
          filter:            "number",
          minWidth:          100,
          suppressSizeToFit: false,
          editable:          false,
          valueGetter:       ( { data } ) => {
            return this.$options.filters.numberWithSpaces(Number(data.amount).toFixed(2));
          },
        },
        {
          headerName:        'Комиссия',
          field:             'amount_agency',
          filter:            "number",
          minWidth:          100,
          suppressSizeToFit: false,
          editable:          false,
          valueGetter:       ( { data } ) => {
            return this.$options.filters.numberWithSpaces(Number(data.amount_agency).toFixed(2));
          },
        },
        {
          headerName:        'Оплачено',
          field:             'all_amount',
          filter:            "number",
          minWidth:          100,
          suppressSizeToFit: false,
          editable:          false,
          valueGetter:       ( { data } ) => {
            return this.$options.filters.numberWithSpaces(Number(data.all_amount).toFixed(2));
          },
        },
        {
          headerName:  'Комментарий',
          field:       'comment',
          flex:        2,
          minWidth:    200,
          filter:      false,
          editable:    false,
          valueGetter: ( { data } ) => {
            return data.comment;
          },
        },
        {
          headerName:            'Чек',
          field:                 'check_number',
          filter:                "number",
          minWidth:              80,
          editable:              false,
          cellRendererFramework: PaymentCheck,
          cellRendererParams:    ( { data } ) => data,
          // valueGetter: ( { data } ) => data.check_number || '-',
        },
        {
          headerName:            '  ',
          field:                 'actions',
          filter:                false,
          sortable:              false,
          minWidth:              140,
          maxWidth:              140,
          editable:              false,
          cellRendererFramework: agGridActions,
          cellRendererParams:    ( { data } ) => {
            if (!data) return {};
            return {
              payment:     data,
              paymentId:   data.id,
              isEditable:  !data.check_print,
              buildingsId: this.selectedHouseId,
              deleted:     () => {
                this.paymentDeleted();
              },
              openEdit:    ( payment ) => {
                this.$router.push({
                  name: 'uc_b_payment',
                  params: {id: payment.id}
                });
                // this.openEditPayment(payment);
              },
              update:      () => this.getPayments(true),
            };
          },
          hide:                  !this.$can('rp.invoices', 'write'),
        },
      ];
    },
    disabledDatesFrom() {
      return {
        from: new Date(this.date_to),
      };
    },
    disabledDatesTo() {
      return {
        to: new Date(this.date_from),
      };
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    newPaymentHasErrors() {
      for (let error in this.newPaymentErrors) {
        if (this.newPaymentErrors.hasOwnProperty(error)) {
          if (this.newPaymentErrors[error] === true)
            return true;
        }
      }
      return false;
    },
  },
  methods:  {
    goToUnresolvedPayments() {
      this.$router.push({
        name: 'uc_b_unresolved_payments',
      });
    },
    paymentDeleted() {
      this.$vs.notify({
        color: 'success',
        title: 'Успешное удаление',
        text:  'Платеж удален',
      });
      this.getPayments(true);
    },
    getDate( stringToParse ) {
      let month = +(stringToParse.split('-')[1]);
      let year = +(stringToParse.split('-')[0]);
      let day = +(stringToParse.split('-')[2]);
      let date = new Date();
      date.setFullYear(year, month - 1, day);
      return date;
    },
    openEditPayment( payment ) {
      Object.assign(this.newPayment, payment);
      this.newPayment.payment_passage_date = this.getDate(this.newPayment.payment_passage_date);
      this.newPayment.payment_create_date = this.getDate(this.newPayment.payment_create_date);
      this.newPayment.monthyear = this.newPayment.monthyear ? this.$parseDateFromString(this.newPayment.monthyear) : null;
      this.$refs.newPaymentCreateDate.$children[0].setValue(this.newPayment.payment_passage_date);
      this.$refs.newPaymentPassageDate.$children[0].setValue(this.newPayment.payment_create_date);
      this.$refs.newPaymentMonthyear.$children[0].setValue(this.newPayment.monthyear);
      this.isNewPaymentOpen = true;
    },
    getPaymentsTypeById( id ) {
      if (this.paymentTypes) {
        let type = this.paymentTypes.find(type => type.id === id);
        return type ? type.name : 'Не известный';
      }
      return 'Не известный';
    },
    resetErrors() {
      for (let error in this.newPaymentErrors) {
        if (this.newPaymentErrors.hasOwnProperty(error)) {
          this.newPaymentErrors[error] = false;
        }
      }
    },
    resetNewPayment() {
      for (let field in this.newPayment) {
        if (this.newPayment.hasOwnProperty(field)) {
          this.newPayment[field] = null;
        }
      }
      this.newPayment.payment_passage_date = new Date();
      this.newPayment.payment_create_date = new Date();
      this.newPayment.monthyear = null;
      this.$refs.newPaymentPassageDate.$children[0].setValue(new Date());
      this.$refs.newPaymentCreateDate.$children[0].setValue(new Date());
      this.$refs.newPaymentMonthyear.$children[0].setValue(null);
    },
    getPayments() {
      this.$refs.table.resetData();
    },
    async addIdenticPayment() {
      let body = {
        account_number:       this.newPayment.account_number,
        buildings_id:         this.selectedHouseId,
        payment_create_date:  this.newPayment.payment_create_date,
        payment_passage_date: this.newPayment.payment_passage_date,
        monthyear:            this.newPayment.monthyear ? this.$options.filters.formatDate(this.newPayment.monthyear) : null,
        register:             this.newPayment.register,
        check_number:         this.newPayment.check_number,
        all_amount:           this.newPayment.all_amount,
        type:                 this.newPayment.type,
        check_print:          this.newPayment.check_print,
        who:                  this.$store.getters['appUser/id'],
        force:                true,
      };

      try {
        let { data } = await this.$http.post('invoice', body);

        if (data === 'account not found') {
          this.$vs.notify({
            color: 'danger',
            title: 'Ошибка добавления',
            text:  'Не найдено помещение по номеру лицевого счета',
          });
        } else {
          this.$vs.notify({
            color: 'success',
            title: 'Успешное добавление',
            text:  'Платеж добавлен',
          });
          this.getPayments(true);
          this.isNewPaymentOpen = false;
          this.isIdenticPaymentsOpen = false;
        }


      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    async addPayment() {
      this.resetErrors();

      let getDoubleWithDot = ( num ) => {
        if (num === null) return null;
        let val = String(num).replace(/,/g, '.');
        return Number(val);
      };

      let checkDoubleErrors = ( num ) => {
        if (num === null) {
          return true;
        }
        let val = getDoubleWithDot(num);
        return isNaN(val);
      };

      if (this.newPayment.account_number === null) {
        this.newPaymentErrors.account_number = true;
      }
      if (this.newPayment.type === null) {
        this.newPaymentErrors.type = true;
      }
      if (this.newPayment.payment_create_date === null) {
        this.newPaymentErrors.payment_create_date = true;
      }
      if (this.newPayment.payment_passage_date === null) {
        this.newPaymentErrors.payment_passage_date = true;
      }

      if (checkDoubleErrors(this.newPayment.all_amount)) {
        this.newPaymentErrors.all_amount = true;
      }

      if (this.newPayment.id) {
        if (checkDoubleErrors(this.newPayment.amount_agency)) {
          this.newPaymentErrors.amount_agency = true;
        }
        if (checkDoubleErrors(this.newPayment.amount)) {
          this.newPaymentErrors.amount = true;
        }
      }

      if (this.newPaymentHasErrors) {
        return;
      }


      let body = {
        buildings_id:         this.selectedHouseId,
        account_number:       this.newPayment.account_number,
        payment_create_date:  this.newPayment.payment_create_date,
        payment_passage_date: this.newPayment.payment_passage_date,
        monthyear:            this.newPayment.monthyear ? this.$options.filters.formatDate(this.newPayment.monthyear) : null,
        register:             this.newPayment.register,
        check_number:         this.newPayment.check_number,
        all_amount:           getDoubleWithDot(this.newPayment.all_amount),
        type:                 this.newPayment.type,
        check_print:          this.newPayment.check_print,
        who:                  this.$store.getters['appUser/id'],
        comment:              this.newPayment.comment !== null && this.newPayment.comment.length ? this.newPayment.comment : null,
      };

      try {
        if (this.newPayment.id) {
          body.id = this.newPayment.id;
          if (!this.newPayment.check_print) {
            body.amount = getDoubleWithDot(this.newPayment.all_amount) - getDoubleWithDot(this.newPayment.amount_agency);
            body.amount_agency = getDoubleWithDot(this.newPayment.amount_agency);
          }
          await this.updatePayment(body);
        } else {
          try {
            let { data } = await this.$http.post('invoice', body);
            if (data === 'already exists') {
              this.$vs.notify({
                color: 'danger',
                title: 'Ошибка добавления',
                text:  'Чек с таким номером уже существует',
              });
              return;
            } else if (data === 'account not found') {
              this.$vs.notify({
                color: 'danger',
                title: 'Ошибка добавления',
                text:  'Не найдено помещение по номеру лицевого счета',
              });
            } else if (data.message === 'Great success! Invoice created') {
              this.$vs.notify({
                color: 'success',
                title: 'Успешное добавление',
                text:  'Платеж добавлен',
              });
            } else {
              this.identicPayments = data;
              this.isIdenticPaymentsOpen = true;
              return;
            }
          } catch (e) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка добавления', text: 'Ошибка сервера' });
          }

        }

        this.getPayments(true);
        this.isNewPaymentOpen = false;
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }

        this.isNewPaymentOpen = false;
      }
    },
    async getTypes() {
      try {
        let { data } = await this.$http.get('invoices_type');
        this.paymentTypes = data;
      } catch (e) {
        this.paymentTypes = [
          {
            "id":   1,
            "name": "Ведомость по умолчанию",
          },
        ];
      }
    },
    async getAparts() {
      let { data } = await this.$http.get(`all_aparts?buildings_id=${this.selectedHouseId}`);
      this.apartments = data.filter(apartment => apartment.account_number);
    },
    resetLazyLoadingData() {
      this.$refs.table.resetLazyLoadingData();
    },

    updatePayment( body ) {
      return new Promise(async resolve => {
        try {
          let { data } = await this.$http.put('invoice/' + body.id, body);
          if (data !== 'check already print') {
            this.$vs.notify({ color: 'success', title: 'Успешное изменение', text: 'Платеж изменен' });
            resolve(true);
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибочное редактирование',
              text:  'Платеж не изменен, т.к. чек уже распечатан',
            });
            resolve(false);
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status === 403) {
              this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
            } else {
              this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
            }
          } else {
            this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
          }
          resolve(false);
        }
      });
    },

    getPinnedRows( filters, orderBy ) {
      return new Promise(async ( resolve ) => {

        let data = {
          amount:        this.totalAmount,
          amount_agency: this.totalAmountAgency,
          all_amount:    this.totalAllAmount,
        };

        resolve([data]);
      });
    },
    getData( page, filters, orderBy ) {
      return new Promise(async ( resolve ) => {
        let { data } = await this.$http.get('invoice', {
          params: {
            orderby:      orderBy,
            filters:      filters,
            page:         page,
            buildings_id: this.selectedHouseId,
            from:         this.$options.filters.formatDate(this.date_from),
            to:           this.$options.filters.formatDate(this.date_to),
          },
        });
        this.totalAmount = data.total_amount;
        this.totalAmountAgency = data.total_amount_agency;
        this.totalAllAmount = data.total_all_amount;

        this.$refs.table.updatePinnedRows();

        resolve({
          response: data.invoices,
          total:    data.invoices.total,
          data:     data.invoices.data,
        });
      });
    },

    async exportTable() {
      this.exportInProgress = true;
      this.$refs.table.exportRows('Платежи')
        .catch(this.notifyHttpError)
        .finally(() => this.exportInProgress = false);
    },
  },
  async beforeMount() {
    await this.getTypes();
  },
  mounted() {
    this.getAparts();
  },
  watch: {
    isNewPaymentOpen() {
      if (!this.isNewPaymentOpen) {
        this.resetErrors();
        this.resetNewPayment();
      }
    },
    selectedHouseId() {
      this.getPayments();
      this.getAparts();
    },
    date_from() {
      this.getPayments();
    },
    date_to() {
      this.getPayments();
    },
  },
};
</script>

<style lang="scss">
.identicPaymentPopup {
  .vs-popup {
    width: 800px;
  }
}
</style>
